import './Btns.scss';

function Btns(props) {
return (
    <div className = 'cart_btn'>
        <a className = 'btn-read' href="https://www.pult.ru/articles/proigryvateli-i-rekordery/poveliteli-diskov-universalnye-proigryvateli-reavon/">
            Читать статью
            <img  loading="lazy" alt = "" src = "/img/book-open.svg"></img>
        </a>
        <a className = 'btn-buy' href={props.card.href}>
            Купить
            <img  loading="lazy" alt = "" src = "/img/shop.svg"></img>
        </a>
    </div>
)
}
export default Btns;